export const enum LayerType {
    BARRIER_FENCES = "barrierFences",
    KNOWN_REGIONS = "knownRegions",
    RELEASE_SITES = "releaseSites",
    RHD_BOOST_ROLLOUT_SITES = "rhdBoostRollOutSites",
    SUCCESSFUL_EOI_SITES = "successfulEoiSites"
}